/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Gateway timeout model
 * @export
 * @interface GatewayTimeout
 */
export interface GatewayTimeout {
    /**
     * Gateway timeout message
     * @type {string}
     * @memberof GatewayTimeout
     */
    error: string;
    /**
     * number of seconds the request was given
     * @type {number}
     * @memberof GatewayTimeout
     */
    timeout?: number;
}

/**
 * Check if a given object implements the GatewayTimeout interface.
 */
export function instanceOfGatewayTimeout(value: object): value is GatewayTimeout {
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function GatewayTimeoutFromJSON(json: any): GatewayTimeout {
    return GatewayTimeoutFromJSONTyped(json, false);
}

export function GatewayTimeoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): GatewayTimeout {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'],
        'timeout': json['timeout'] == null ? undefined : json['timeout'],
    };
}

export function GatewayTimeoutToJSON(json: any): GatewayTimeout {
    return GatewayTimeoutToJSONTyped(json, false);
}

export function GatewayTimeoutToJSONTyped(value?: GatewayTimeout | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
        'timeout': value['timeout'],
    };
}

